let Hooks = {}

Hooks.Countdown = {
    mounted() {
        this.start();
    },

    updated() {
        if (this.el.dataset.restart !== this.restart) this.start();
    },

    destroyed() {
        clearInterval(this.timer);
    },

    value() {
        return this.el.querySelector("#offline-countdown-value");
    },

    start() {
        clearInterval(this.timer);
        this.restart = this.el.dataset.restart;
        this.remaining = parseInt(this.el.dataset.seconds, 10);
        this.render();

        this.timer = setInterval(() => {
            this.remaining -= 1;
            this.render();
            if (this.remaining <= 0) clearInterval(this.timer);
        }, 1000);
    },

    render() {
        this.value().textContent = this.el.dataset.format.replace("%{seconds}", Math.max(this.remaining, 0));
    }
}

Hooks.LocalProbe = {
    mounted() {
        this.probe();
    },

    updated() {
        if (this.el.dataset.attempt !== this.attempt) this.probe();
    },

    probe() {
        this.attempt = this.el.dataset.attempt;
        const image = new Image();
        image.onload = () => this.pushEvent("local_probe", {reachable: true});
        image.onerror = () => this.pushEvent("local_probe", {reachable: false});
        image.src = this.el.dataset.url + "?attempt=" + this.attempt;
    }
}

export {Hooks}
